import makeStyles from '@mui/styles/makeStyles';

const claimSubmissionInformationStyle = makeStyles(
  {
    submissionDetail: { marginBottom: '24px', width: '93%' },
    header: {
      fontSize: '20px',
      lineHeight: '24px',
      letterSpacing: '0.15px',
      fontWeight: '500',
      color: '#2196F3',
      marginTop: '48px',
      marginBottom: '24px',
    },
    titleWrapper: { display: 'flex', justifyContent: 'space-between' },
    title: {
      fontSize: '12px',
      lineHeight: '32px',
      letterSpacing: '1px',
      fontWeight: 'normal',
      color: '#2D2D2D',
    },
    detail: {
      fontSize: '12px',
      lineHeight: '20px',
      letterSpacing: '0.4px',
      fontWeight: 'normal',
      color: '#00000099',
    },
    claimTypeButton: {
      padding: 0,
      minWidth: 'unset',
      textTransform: 'none',
    },
    claimTypeEditable: {
      fontSize: '12px',
      lineHeight: '20px',
      letterSpacing: '0.4px',
      fontWeight: 'normal',
      color: '#2196F3',
    },
  },
  { name: 'claim-submission-information' }
);

export { claimSubmissionInformationStyle };
